import { buildLocalizedHref, resolveInternalPath, splitLocaleFromPathname } from "../../app/lib/routeUtils";

export function getBreadcrumbItems(locale, pathname, labels) {
  const { path } = resolveInternalPath(locale, splitLocaleFromPathname(pathname).pathname);
  const segments = path.split("/").filter(Boolean);
  const items = labels || segments;
  return items.map((label, index) => ({
    label,
    // Display-only category names are not routes (e.g. Products / By Industry).
    href: index === items.length - 1
      ? buildLocalizedHref(locale, path)
      : labels ? null : buildLocalizedHref(locale, segments.slice(0, index + 1).join("/")),
  }));
}
